import { render } from "./Register.vue?vue&type=template&id=1b9a9f47&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"

import "./Register.vue?vue&type=style&index=0&id=1b9a9f47&scoped=true&lang=css"

import exportComponent from "C:\\Users\\yojan\\Documents\\Adlightech\\Development\\Contact-leads2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b9a9f47"]])

export default __exports__